import { Box, Grid, Typography } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";
import PhoneField from "../../../common/components/functional/phoneField/PhoneField";

const FormRow = ({
  name,
  rules,
  edit,
  maxWidth,
  showTooltip,
}: {
  name: string;
  rules: object;
  edit: boolean | null;
  maxWidth: string;
  showTooltip: boolean;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { t } = useTranslation("talentProfile");

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t(name)}
        </Typography>
      </Grid>
      <Grid item container xs={9}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { name, value, onChange } }) =>
            edit ? (
              <>
                <PhoneField
                  value={value}
                  onChange={onChange}
                  fullWidth={false}
                  error={!!errors[name]}
                />
                {showTooltip && (
                  <Box display="flex" alignItems="center" marginLeft="13px">
                    <InfoTooltip
                      title={t(`talentProfile:phoneNumberInvalid`)}
                    />
                  </Box>
                )}
              </>
            ) : (
              <Typography>{value}</Typography>
            )
          }
        />
      </Grid>
    </>
  );
};

export default FormRow;
